import React, { Component } from 'react';

import classNames from 'classnames';
import { PropTypes } from 'prop-types';

import ConfigListItem from './ConfigListItem';

import './ConfigList.scss';

export default class ConfigList extends Component {
  static propTypes = {
    items: PropTypes.array,
    className: PropTypes.string,
    params: PropTypes.object,
    large: PropTypes.bool
  };

  resolveParams = (item) => {
    const paramKeys = item.data || [];
    const paramValues = this.props.params || [];
    const labelParams = {};

    paramKeys.forEach((key) => {
      labelParams[key] = paramValues[key];
    });

    return labelParams;
  };

  render() {
    const { items, className, large } = this.props;

    return (
      <div
        className={classNames('config-list config-list__list', className, {
          'config-list__list--large': large
        })}
      >
        <ul>
          {(items || []).map((item, index) => {
            return (
              <ConfigListItem
                large={large}
                item={item}
                key={`config-list__${index}`}
                params={this.resolveParams(item)}
              />
            );
          })}
        </ul>
      </div>
    );
  }
}
